import {Component, inject, input} from '@angular/core';
import {IonCard, IonCardContent, IonContent, IonText, PopoverController} from '@ionic/angular/standalone';

@Component({
	           selector: 'app-message-popin',
	           standalone: true,
	           template: `
		           <ion-content>
@if (message()) {
	<div>
        <ion-card class="m-0">
            <ion-card-content><ion-text></ion-text></ion-card-content>
        </ion-card>
	  </div>
}
</ion-content>`,
	           imports: [
		           IonContent,
		           IonCard,
		           IonCardContent,
		           IonText
	           ],
	           styleUrls: ['./message-popin.component.scss']

           })
export class MessagePopinComponent {

	message = input.required<string>();
	private popover = inject(PopoverController);

	constructor() {
	}

	closePopover() {
		return this.popover.dismiss();
	}
}
